import styled, { css } from 'styled-components';
import Select from '../../components/Common/Select';
import Submit from '../components/Submit';
import TimeZoneConnected from '../../components/Common/TimeZone';

export const StyledGoNextMonthButton = styled(Select)`
  margin-top: 10px;
`;

export const StyledTimeZone = styled(TimeZoneConnected)`
  text-align: left;
`;

export const StyledSubmit = styled(Submit)`
  && {
    margin-top: 20px;
  }
`;

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const { 
      color,
      inputsLabelsTextAlign,
      inputsBorderRadius,
      calendarBorderRadius,
      calendarCellsBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};
    const {
      padding: containerPadding,
      margin: containerMargin,
      widgetContainerBorderRadius
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }

      .rdp-head {
        .rdp-head_row {
          border-radius: ${calendarBorderRadius}px;
        }
      }
      
      .rdp-cell {
        button.rdp-button {
          border-radius: ${calendarCellsBorderRadius}px !important;
        }
      }

      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
      
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }
        
      .locations-select, .resources-select {
        .titles {
          display: inline-block;
          width: 100%; 
          text-align: ${inputsLabelsTextAlign};
        }  
      }  

      .sub-panel {
        border-radius: ${widgetContainerBorderRadius}px;
        padding: ${containerPadding}px;
        margin: ${containerMargin}px;
      }
    `;
  }
}`;
